import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';

interface BoxProps {
  $autoHeight?: boolean;
  $tone?: 'alt' | 'secondary' | 'accent';
  $borderStyle?: 'solid' | 'dashed';
  $size?: 'small' | 'medium';
}
export const Box = styled.div<BoxProps>`
  --box-bg: var(--c-bg-main);
  --box-fg: var(--c-text-main);
  --box-border: var(--c-border-main);
  --box-border-style: solid;

  display: flex;
  flex-direction: column;
  background-color: var(--box-bg);
  color: var(--box-fg);
  border: 1px var(--box-border-style) var(--box-border);
  border-radius: ${size(1)};
  min-width: 0;

  ${({ $autoHeight }) =>
    $autoHeight
      ? ''
      : css`
          height: 100%;
        `}

  ${({ $tone }) =>
    $tone === 'alt'
      ? css`
          --box-bg: var(--c-bg-primary);
        `
      : $tone === 'secondary'
        ? css`
            --box-bg: var(--c-secondary-bg);
          `
        : $tone === 'accent'
          ? css`
              --box-bg: var(--c-accent-bg);
              --box-fg: var(--c-accent-fg);
            `
          : undefined}

  ${({ $size }) =>
    $size === 'small'
      ? css`
          padding: ${size(1.5)};`
      : css`
          padding: ${size(2)};
        `}
`;
